import axios from 'axios';
import { notifyError } from '../helpers/notifications';

const instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
});

instance.defaults.headers.common['Content-Type'] = 'application/json'
instance.defaults.withCredentials = true

instance.interceptors.response.use(
    (response) => {
        return response
    },
    async (error) => {
        const error_response = (error.response && error.response.data) || {}
        const status = error.response && error.response.status

        const requestUrl = (error.config && error.config.url) || '';
        if (status === 401 && !String(requestUrl).includes('logout') && !String(requestUrl).includes('get-refresh-token-pair')) {
            try {
                await axios({
                    method: 'GET',
                    baseURL: process.env.VUE_APP_BASE_URL,
                    url: 'auth/get-refresh-token-pair',
                    withCredentials: true,
                })
                return instance(error.config)
            } catch (refreshError) {
                notifyError({ title: 'Сессия истекла', errors: 'Войдите снова' })
                return Promise.reject(refreshError)
            }
        }

        notifyError({
            title: error_response.error_message || 'Ошибка запроса',
            errors: error_response.errors || error.message,
        })
        return Promise.reject(error)
    }
)

export default instance
